module.exports = __webpack_public_path__ + "cbd2c1f25d9c5d8a7f773341065e4a80.MP3";